export { default, GlobalContextProvider } from './GlobalContext';
